













































































import InformationRow from '@/components/display/information-row.vue';
import { Component, Emit, Prop, PropSync, Vue } from 'vue-property-decorator';
import FormInputRow from '@/components/form pickers/FormInputRow.vue';
import { ConsentWithId } from '@/api';
import { ConsentCouncil, ConsentModule, OrgsModule } from '@/modules';
import Toast from '@/components/display/toast.vue';
import debounce from 'lodash.debounce';
import { cloneDeep } from 'lodash';

@Component({
	components: {
		FormInputRow,
		InformationRow,
	},
})
export default class WaterConsentSettings extends Vue {
	private readonly toast: Toast = new Toast();
	private readonly consentModule: ConsentModule = new ConsentModule();
	private readonly orgsModule: OrgsModule = new OrgsModule();

	@Prop({ required: true })
	public productId!: number;

	@PropSync('consent', { required: true })
	public _consent!: ConsentWithId &
		ConsentCouncil & { active?: boolean; consentconditions?: any[] };

	protected consentCouncilOptions: { text?: string; value?: any }[] = [];

	protected editing: { consentIdentifier: boolean } = { consentIdentifier: false };
	protected previous: { consentIdentifier?: string } = {};
	protected consentDatePicker: { start?: string; end?: string } = {};

	protected consentActiveOptions = [
		{ text: 'Yes', value: true },
		{ text: 'No', value: false },
	];

	protected updating: boolean = false;

	constructor() {
		super();
		this.updateSettings = <() => Promise<void>>debounce(this.updateSettings, 100);
	}

	public async mounted() {
		this.consentDatePicker = {
			start: this._consent.startDate,
			end: this._consent.endDate,
		};

		const councils = await this.orgsModule.getRegionalCouncil();
		if (councils?.length)
			this.consentCouncilOptions = councils.map(council => ({
				text: council.name,
				value: council.id,
			}));

		this.previous = cloneDeep(this._consent);
	}

	protected async consentDatePickerChanged(): Promise<void> {
		this._consent.startDate = this.consentDatePicker.start;
		this._consent.endDate = this.consentDatePicker.end;
		await this.updateSettings();
	}

	protected async updateSettings(): Promise<void> {
		this.updating = true;
		const success = await this.consentModule.save(this._consent);
		if (success) {
			this.previous = cloneDeep(this._consent);
			this.toast.makeToast('Updated consent settings', 'Success', 'success');
			this.reloadConsents();
		} else this.toast.makeToast('Failed to update consent settings', 'Error', 'danger');
		this.updating = false;
	}

	protected toggleEditingConsentIdentifier(editing: boolean, update: boolean = true): void {
		this.editing.consentIdentifier = editing;
		if (!editing && this.previous.consentIdentifier !== this._consent.consentIdentifier) {
			if (update) this.updateSettings();
			else this._consent.consentIdentifier = this.previous.consentIdentifier;
		}
	}

	@Emit('reloadConsents')
	public reloadConsents(): void {}
}
